

import React, { useContext, useEffect, useRef, useState } from "react";
import { FormFieldDataFormat } from "@syncfusion/ej2-react-pdfviewer";

import {
  Box, Link, Fab, Card, Typography, IconButton, Modal,
  TextField, Button, Snackbar,
} from "@mui/material/";
import Clear from "@mui/icons-material/Clear";
import Save from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import {
  PdfViewerComponent,
  Toolbar,
  Magnification,
  Navigation,
  LinkAnnotation,
  BookmarkView,
  ThumbnailView,
  Print,
  TextSelection,
  Annotation,
  TextSearch,
  Inject,
  FormFields,
  DisplayMode,
  FormDesigner

} from "@syncfusion/ej2-react-pdfviewer";
import { db } from "config/config";
import {
  getFirestore,
  collection,
  query,
  orderBy,
  limit,
  startAfter,
  getDocs,
  where,
  or
} from "firebase/firestore";
import "../styles/editorOverride.css";
import InfiniteScrollSelect, { fetchData } from "./shared/InfiniteScrollSelect";
import { columnSelectionComplete } from "@syncfusion/ej2-react-grids";
import "../styles/PDFViewer.css"
import firebase from "firebase/compat/app";
import MuiAlert from "@mui/material/Alert";
import { CreateUniqueDocument } from "components/shared/createUniqueDocument ";
import { Context } from "context/Wrapper";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { CurrencyBitcoinRounded } from "@mui/icons-material";
import tableConfig from "config/advancedTableColumnsControl.json";
import { display } from "@mui/system";
import DownloadConfirmDialog from "./DownloadConfirmDialog";



const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const PDFViewer = ({
  formToView,
  handleSave,
  handleCloseViewer,
  setLoading,
  isNewForm,
  autoFillDetails,
  isInactive,
  downloadFromForm,
  setDownloadFromForm
}) => {



  const childRef = useRef();
  const [hasTwoOptionRadio, setHasTwoOptionRadio] = useState(false);

  const [fieldArray, setFieldArray] = useState([]);
  // const isNewForm = true;

  const [pageNumber, setPageNumber] = useState(0);

  const baseUrl = `${window.location.protocol}//${window.location.host}/${process.env.PUBLIC_URL}`;
  const [selectAllNoActive, setSelectAllNoActive] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const pendingToolbarDownload = useRef(false);


  const navigate = useNavigate()
  const context = useContext(Context);

  const { groupId, isPro, userId } = context?.state?.userProfile || {};
  const user = context?.state?.userProfile || {};
  const { showAllDataFlag } = context?.state || {};
  let searchTimeout = null






  const [openModal, setOpenModal] = useState(false);
  const [fullName, setFullName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [businessName, setBusinessName] = useState('');
  const [address1, setaddress1] = useState('');
  const [city, setcity] = useState('');
  const [state, setstate] = useState('');
  const [ZIP, setZIP] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');

  const [shouldReevaluateVisibility, setShouldReevaluateVisibility] = useState(false);
  const [currentPrefix, setCurrentPrefix] = useState('')

  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    severity: 'success'
  });




  function extractKeyValuePairs(arr) {
    const result = [];

    arr.forEach((item) => {
      if (item.details) {
        const prefix = item.prefix;
        const details = item.details;

        for (const key in details) {
          if (details.hasOwnProperty(key)) {
            const keyValue = `${prefix}${key}`;
            const value = details[key];
            result.push({ name: keyValue, value: value, type: "Textbox" });
          }
        }
      }

    });

    return result;
  }

  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
      if (searchTimeout) clearTimeout(searchTimeout);
    };
  }, []);



  const onHandleSave = async () => {
    setLoading(true);
    const viewer = childRef.current;

    try {
      if (selectAllNoActive) {
        const currentPage = viewer.currentPageNumber;
        for (let i = 1; i <= viewer.pageCount; i++) {
          await viewer.navigation.goToPage(i);
          await new Promise(resolve => setTimeout(resolve, 100));
          updateAllNo();
        }
        await viewer.navigation.goToPage(currentPage);
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      const formFieldsObj = await viewer.exportFormFieldsAsObject(FormFieldDataFormat.Json);
      const annotationsObj = await viewer.exportAnnotationsAsObject();

      handleSave(
        formFieldsObj,  // ← Remove JSON.stringify
        annotationsObj,
        formToView.formId
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    return () => {
      const viewer = childRef.current;
      if (viewer && typeof viewer.destroy === 'function') {
        viewer.destroy();
      }
    };
  }, []);

  const updateAllNo = () => {
    const viewer = childRef.current;
    if (!viewer) return;

    const allFields = Array.from(viewer.formFieldCollections)
      .filter(f => f.type === 'RadioButton');
    const groupNames = [...new Set(allFields.map(f => f.name))];

    groupNames.forEach(name => {
      const radios = Array.from(
        document.querySelectorAll(`input[name="${name}"]`)
      );
      if (radios.length !== 2) return;

      if (radios.some(r => r.checked)) return;

      const noInput = radios.find(r => r.value === "2");
      if (!noInput) return;

      noInput.checked = true;

      const fieldObj = allFields.find(f => f.id === noInput.id);
      if (fieldObj) {
        fieldObj.value = noInput.value;
        fieldObj.isSelected = true;
        try {
          viewer.updateFormFieldsValue(fieldObj);
        } catch (e) {
          console.warn(`Failed to update ${fieldObj.name}`, e);
        }
      }
    });
  };

  const handleToolbarClick = args => {
    args.originalEvent.preventDefault();
    if (args.item.id !== 'selectAllN') return;

    updateAllNo();
    setSelectAllNoActive(true);
  };

const onDocLoad = async (args) => {
  const viewer = childRef.current;
  if (!viewer) return;

  if (downloadFromForm) {
    pendingToolbarDownload.current = false;
    setConfirmOpen(true);
    return;
  }

  if (formToView.formContent) {
    try {
      let saved = formToView.formContent;

      if (typeof saved === "string") saved = JSON.parse(saved);
      if (typeof saved === "string") saved = JSON.parse(saved);

      Object.keys(saved).forEach((k) => {
        if (saved[k] === "Off") saved[k] = false;
        if (saved[k] === "On") saved[k] = true;
      });

      const fixedFields = {};
      Object.keys(saved).forEach((key) => {
        const fixedKey = key.replace(/\\\]0\]/g, "[0]");
        fixedFields[fixedKey] = saved[key];
      });

      const normalizedFields = {};
      Object.keys(fixedFields).forEach((key) => {
        const normalizedKey = key.replace(/_/g, "");
        normalizedFields[normalizedKey] = fixedFields[key];
      });

      await new Promise((resolve) => setTimeout(resolve, 300));

      Object.keys(fixedFields).forEach((fieldName) => {
        // Try multiple matching strategies
        let field = null;

        // Strategy 1: Exact match
        field = viewer.formFieldCollections.find(f => f.name === fieldName);

        // Strategy 2: Try with normalized name (without underscores)
        if (!field) {
          const normalizedName = fieldName.replace(/_/g, "");
          field = viewer.formFieldCollections.find(f => f.name === normalizedName);
        }

        // Strategy 3: Try partial match for fields with brackets
        if (!field && fieldName.includes('[')) {
          const simplifiedName = fieldName.replace(/\\\]0\]/g, "").replace(/\[0\]/g, "");
          field = viewer.formFieldCollections.find(f => f.name.includes(simplifiedName));
        }

        // Strategy 4: Try matching the base name without any formatting
        if (!field) {
          const baseName = fieldName.replace(/[^a-zA-Z0-9]/g, "");
          field = viewer.formFieldCollections.find(f =>
            f.name.replace(/[^a-zA-Z0-9]/g, "") === baseName
          );
        }

        if (!field) {
          return;
        }

        const fieldValue = fixedFields[fieldName];

        if (field.type === "CheckBox") {
          if (fieldValue === "1" || fieldValue === true) {
            field.isChecked = true;
            field.value = true;
          } else {
            field.isChecked = false;
            field.value = false;
          }

          try {
            viewer.updateFormFieldsValue(field);
          } catch (err) {
            console.warn("Failed to update checkbox:", field.name, err);
          }
        }

        else if (field.type === "RadioButton") {
          const groupName = field.name;
          const radiosInGroup = viewer.formFieldCollections.filter(
            (f) => f.name === groupName && f.type === "RadioButton"
          );

          radiosInGroup.forEach((radio) => {
            radio.isSelected = false;
            try {
              viewer.updateFormFieldsValue(radio);
            } catch (err) {
              console.warn("Failed to clear radio:", radio.name, err);
            }
            const el = document.getElementById(radio.id);
            if (el && el.type === "radio") el.checked = false;
          });

          const targetRadio = radiosInGroup.find(
            (r) => String(r.value) === String(fieldValue)
          );

          if (targetRadio) {
            targetRadio.isSelected = true;
            targetRadio.value = String(fieldValue);

            try {
              viewer.updateFormFieldsValue(targetRadio);
            } catch (err) {
              console.warn("Failed to update selected radio:", targetRadio.name, err);
            }

            setTimeout(() => {
              const el = document.getElementById(targetRadio.id);
              if (el && el.type === "radio") el.checked = true;
            }, 50);
          }
        }

        else {
          if (fieldValue && fieldValue !== "") {
            field.value = fieldValue;
            
            try {
              viewer.updateFormFieldsValue(field);
              
              // Force update for problematic fields
              if (fieldName.includes('TOTAL_JOB_COST')) {
                setTimeout(() => {
                  const inputElement = document.getElementById(field.id);
                  if (inputElement) {
                    inputElement.value = field.value;
                  }
                }, 100);
              }
            } catch (err) {
              console.warn("Failed to update text field:", field.name, err);
            }
          }
        }
      });

      const initialFieldArray = [];
      viewer.formFieldCollections.forEach((field) => {
        const fieldValue = normalizedFields[field.name];
        if (field.type === "RadioButton" && fieldValue) {
          initialFieldArray.push({
            id: field.id,
            type: "RadioButton",
            name: field.name,
            value: fieldValue,
            isSelected: true,
            filled: false,
          });
        } else if (field.type === "CheckBox" && fieldValue === true) {
          initialFieldArray.push({
            id: field.id,
            type: "CheckBox",
            name: field.name,
            value: true,
            isChecked: true,
            filled: false,
          });
        }
      });
      setFieldArray(initialFieldArray);

      await new Promise((resolve) => setTimeout(resolve, 100));

      // Force refresh of TOTAL_JOB_COST field as final step
      setTimeout(() => {
        if (viewer && viewer.formFieldCollections) {
          viewer.formFieldCollections.forEach(field => {
            if (field.name.includes('TOTAL_JOB_COST') && field.value) {
              viewer.updateFormFieldsValue(field);
              
              const inputEl = document.getElementById(field.id);
              if (inputEl) {
                inputEl.dispatchEvent(new Event('change', { bubbles: true }));
                inputEl.dispatchEvent(new Event('input', { bubbles: true }));
                inputEl.value = field.value;
              }
            }
          });
        }
      }, 500);

    } catch (e) {
      console.error("Failed to load form data:", e);
    }
  }

  if (isNewForm) {
    const autoFillFields = extractKeyValuePairs(autoFillDetails);
    autoFillFields.forEach(({ name, value, type }) => {
      const f = viewer.formFieldCollections.find((f) => f.name === name);
      if (!f) return;
      if (value !== undefined && value !== null) {
        f.value = value;
        try {
          viewer.updateFormFieldsValue(f);
        } catch (err) {
          console.warn("Error updating field:", f.name, err);
        }
      }
    });
  }

  if (formToView.formAnnotations && viewer?.importAnnotation) {
    try {
      const parsedAnn =
        typeof formToView.formAnnotations === "string"
          ? JSON.parse(JSON.parse(formToView.formAnnotations))
          : formToView.formAnnotations;
      if (parsedAnn) viewer.importAnnotation(parsedAnn);
    } catch (e) {
      console.error("Failed to import annotations:", e);
    }
  }

  const todayDate = new Date().toLocaleDateString("en-CA");
  if (viewer.formFieldCollections) {
    viewer.formFieldCollections
      .filter(
        (field) =>
          field &&
          field.name === "todaysDate" &&
          typeof field.value !== "undefined"
      )
      .forEach((field) => {
        try {
          const updatedField = { ...field, value: todayDate };
          if (viewer.updateFormFieldsValue) {
            viewer.updateFormFieldsValue(updatedField);
          }
        } catch { }
      });
  }

  listenForFormFieldChanges();
  setTimeout(evaluateTwoOptionRadio, 300);
  setTimeout(() => setShouldReevaluateVisibility((p) => !p), 150);
  setupFieldObserver();
};


  const handleCancelDownload = () => {
    setConfirmOpen(false);
    if (downloadFromForm) {
      setDownloadFromForm(false);
      handleCloseViewer();
    }
  };

  const handleProceedDownload = async () => {
    setConfirmOpen(false);
    const viewer = childRef.current;
    try {
      if (pendingToolbarDownload.current) {
        await viewer.download();
      } else {
        if (formToView.formContent) {
          const saved = JSON.parse(formToView.formContent);
          await viewer.importFormFields(saved, FormFieldDataFormat.Json);
          await new Promise(r => setTimeout(r, 300));
        }
        await new Promise(r => setTimeout(r, 500));

        pendingToolbarDownload.current = true;
        await viewer.download();
        handleCloseViewer();
      }

    } catch (e) {
      console.error("Download failed:", e);
      setFeedbackMessage({
        open: true,
        message: "Failed to prepare PDF for download",
        severity: "error",
      });
    } finally {
      pendingToolbarDownload.current = false;
      setDownloadFromForm(false);
    }
  };

  const handleDownloadStart = (args) => {
    if (!pendingToolbarDownload.current) {
      args.cancel = true;
      pendingToolbarDownload.current = true;
      setConfirmOpen(true);
    }
  };



  const evaluateTwoOptionRadio = () => {
    const container = document.getElementById('container');
    if (!container) {
      setHasTwoOptionRadio(false);
      return;
    }

    const radios = Array.from(container.querySelectorAll('input[type="radio"]'));

    const counts = radios.reduce((acc, r) => {
      acc[r.name] = (acc[r.name] || 0) + 1;
      return acc;
    }, {});

    const hasTwo = Object.values(counts).some(c => c === 2);
    setHasTwoOptionRadio(hasTwo);
  };

  const onDocLoadComplete = () => {
    const viewer = childRef.current;
    if (formToView.formAnnotations) {
      const ann = JSON.parse(JSON.parse(formToView.formAnnotations));
      viewer.importAnnotation(ann);
    }

    setTimeout(() => {
      listenForFormFieldChanges();
      evaluateTwoOptionRadio();
    }, 500);
  };




const listenForFormFieldChanges = () => {
    const viewer = childRef.current;
    const formFields = viewer?.retrieveFormFields?.() || [];

    formFields.forEach((field) => {
      const input = document.getElementById(field.id);
      if (input && !input.dataset.bound) {
        input.dataset.bound = "true";
        input.addEventListener("input", (e) => handleFieldChange(e, field));
        input.addEventListener("change", (e) => handleFieldChange(e, field));
        
        input.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            input.blur(); 
          }
        });
      }
    });
  };
  const showAllDataFlagRef = useRef(showAllDataFlag);
  useEffect(() => {
    showAllDataFlagRef.current = showAllDataFlag;
  }, [showAllDataFlag]);




  const handleFieldChange = (event, field) => {
    const { value, checked, type } = event.target;
    const fieldName = field.name || "";
    const lowerFieldName = fieldName.toLowerCase();

    setFieldArray((prevFieldArray) =>
      prevFieldArray.map((item) => {
        if (item.id === field.id) {
          if (type === 'radio') {
            return { ...item, value: checked ? 'RadioButton' : '', isSelected: checked, filled: true };
          } else if (type === 'checkbox') {
            return { ...item, value: checked ? 'CheckBox' : '', isChecked: checked, filled: true };
          } else {
            return { ...item, value: value, filled: true };
          }
        }
        return item;
      })
    );

    const match = lowerFieldName.match(/^(.*?)(lastName|firstName|fullName)$/i);
    if (!match || value.length < 3) return;

    const sectionPrefix = match[1];

    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(async () => {
      const { data } = await fetchData({


        lastVisible: null,
        collectionName: 'contacts',
        searchText: value,
        label: 'fullName',
        conditions:
          userId && groupId && isPro && showAllDataFlagRef.current
            ? [or(where("groupId", "==", groupId), where("userId", "==", userId))]
            : userId
              ? [where("userId", "==", userId)]
              : [],

      });

      if (!isMountedRef.current) return;

      const normalizedValue = value.replace(/\s+/g, '').toLowerCase(); // 
      let matchEntry = data.find((item) =>
        item.fullName?.replace(/\s/g, '').toLowerCase() === normalizedValue
      ) || data.find((item) =>
        item.fullName?.replace(/\s/g, '').toLowerCase().includes(normalizedValue)
      );

      if (matchEntry) {
        handleSelectChange(true, matchEntry, sectionPrefix);
      }
    }, 300);
  };



  const onPageChange = async () => {
    const pdfViewerInstance = childRef.current;
    if (!pdfViewerInstance) return;

    const formFields = pdfViewerInstance.formFieldCollections;
    if (!Array.isArray(fieldArray) || !Array.isArray(formFields)) return;

    await waitForFieldsToBeReady(pdfViewerInstance);

    fieldArray.forEach((item) => {
      const field = formFields.find((formField) => formField.id === item.id);
      if (field && !item.filled) {
        if (item.type === "CheckBox" && item.isChecked) {
          field.isChecked = true;
          field.value = true;
          pdfViewerInstance.updateFormFieldsValue(field);
        }
        if (item.type === "RadioButton" && item.isSelected) {
          field.isSelected = true;
          field.value = item.value;
          pdfViewerInstance.updateFormFieldsValue(field);
        }
        if (item.type === "Textbox" && item.value !== "") {
          field.value = item.value;
          pdfViewerInstance.updateFormFieldsValue(field);
        }
        item.filled = true;
      }
    });

    setTimeout(() => {
      listenForFormFieldChanges();
    }, 300);

    setupFieldObserver();
  };

  const setupFieldObserver = () => {
    const container = document.getElementById("container");
    if (!container) return;

    const observer = new MutationObserver((mutations) => {
      const hasFieldInput = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) =>
          node.nodeType === 1 && node.querySelector?.("input[id]")
        )
      );

      if (hasFieldInput) {
        observer.disconnect();
        listenForFormFieldChanges();
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  };


  const waitForFieldsToBeReady = async (viewer, timeout = 3000) => {
    const start = Date.now();
    return new Promise((resolve) => {
      const check = () => {
        const ready = viewer?.formFieldCollections?.some(f => {
          const el = document.getElementById(f?.id);
          return el !== null;
        });

        if (ready || Date.now() - start > timeout) {
          resolve();
        } else {
          setTimeout(check, 100);
        }
      };
      check();
    });
  };




  function printClicked() {
    var viewer = childRef.current;

    console.log(viewer.print);
  }





  const downloadEnd = () => {
    if (downloadFromForm) {
      handleCloseViewer();
      setDownloadFromForm(false);
      return;
    }
    window.setTimeout(() => onHandleSave(), 100);
  };


  //   const handleSelectChange = (newValue, valueData, prefix) => {
  //  console.log(valueData)
  //  console.log(prefix)


  //     if (newValue) {
  //       const pdfViewerInstance = childRef.current;

  //       if (valueData) {
  //        console.log( Object.entries(valueData))

  //         Object.entries(valueData).forEach(([key, value]) => {
  //           const field = document.querySelector(`input[name="${prefix}${key}"]`);

  //           console.log('field , key',field , key)
  //         console.log(key)
  //           console.log(value)



  //           if (field) {
  //             console.log(field.id)
  //             field.value = value;
  //             pdfViewerInstance.updateFormFieldsValue({ id: field.id, value: value });
  //           }
  //         });
  //       }
  //     }




  //   };

  const handleSelectChange = (newValue, valueData, prefix) => {
    if (!newValue || !valueData) return;
    const viewer = childRef.current;

    let formFields = viewer.formFieldCollections || [];
    if (!Array.isArray(formFields)) formFields = Object.values(formFields);
    formFields = formFields.filter(f => f.name);

    const normalizedPrefix = prefix.toLowerCase();

    formFields
      .filter(f => f.name?.toLowerCase().startsWith(normalizedPrefix))
      .forEach(f => {
        f.value = "";
        try {
          viewer.updateFormFieldsValue(f);
        } catch (err) {
          console.warn("Clear failed:", f.name, err);
        }
      });

    Object.entries(valueData).forEach(([key, value]) => {
      const expected = `${normalizedPrefix}${key}`.toLowerCase();
      formFields
        .filter(f => f.name?.toLowerCase() === expected)
        .forEach(f => {
          if (f.name === "todaysDate") f.value = new Date().toISOString().split("T")[0];
          else if (f.type === "CheckBox" && value) f.value = true;
          else if (f.type === "RadioButton" && value) f.value = true;
          else if (f.type === "Textbox" && value !== "") f.value = value;
          else return;

          f.filled = true;
          try {
            viewer.updateFormFieldsValue(f);
          } catch (err) {
            console.warn("Fill failed:", f.name, err);
          }

          setFieldArray(prev =>
            prev.map(item =>
              item.id === f.id
                ? { ...item, value: f.value, filled: true }
                : item
            )
          );
        });
    });
  };


  const handleOpenModal = (prefix) => {
    setCurrentPrefix(prefix)
    setFullName("");
    setFirstName("");
    setLastName("");
    setBusinessName("");
    setaddress1("");
    setcity("");
    setstate("");
    setZIP("");
    setPhoneNumber("");
    setEmail("");


    setOpenModal(true);
  };


  const handleCloseModal = () => {
    setOpenModal(false);
  };


  const openAddedSuccessfully = async (docref) => {

    const docSnapshot = await getDoc(docref);
    const data = docSnapshot.data();

    handleSelectChange(true, data, currentPrefix)

    openFeedbackMessage('Contact added successfully!', 'success');
    handleCloseModal();
  };

  const handleAddContact = (data) => {
    CreateUniqueDocument({
      disableNavigation: true,
      openAddedSuccessfully,
      navigate,
      db,
      collectionName: "contacts",
      data: {
        fullName,
        firstName,
        lastName,
        businessName,
        address1,
        city,
        state,
        ZIP,
        ...{ phone: phoneNumber },
        email
        , userId: user.uid
        , groupId
      },
      uniqueFieldName: "fullName",
      failureCallback: () => {
        console.error("Error adding document.");
        // setSubmitLoader(false);
        openFeedbackMessage('problem occured!', 'error');
      },
      duplicateCallback: () => {
        // setDuplicateOpen(true);
        // setSubmitLoader(false);
        openFeedbackMessage('Duplicate data!', 'error');
      },
      loadingCallback: () => {
        // setSubmitLoader(true);
      }
    });


  };

  const openFeedbackMessage = (message, severity) => {
    setFeedbackMessage({ open: true, message, severity });
  };

  const handleCloseFeedbackMessage = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setFeedbackMessage({ ...feedbackMessage, open: false });
  };


  const names = {
    app: "Applicant",
    owner: "Owner",
    frep: "Filing Representative",
  };

  return (
    <div style={{ visibility: `${downloadFromForm ? "hidden" : "visible"}` }}>
      <Modal open={openModal} onClose={handleCloseModal}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            backgroundColor: "white",
            padding: 20,
          }}
        >
          <h2>Add New Contact</h2>

          {/* Full Name */}
          <TextField
            label="Full Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
            required
          />

          {/* First Name */}
          <TextField
            label="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          {/* Last Name */}
          <TextField
            label="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          {/* Business Name */}
          <TextField
            label="Business Name"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          {/* Address 1 */}
          <TextField
            label="Address 1"
            value={address1}
            onChange={(e) => setaddress1(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          {/* City */}
          <TextField
            label="City"
            value={city}
            onChange={(e) => setcity(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          {/* State */}
          <TextField
            label="State"
            value={state}
            onChange={(e) => setstate(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          {/* ZIP */}
          <TextField
            label="ZIP"
            value={ZIP}
            onChange={(e) => setZIP(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          {/* Phone Number */}
          <TextField
            label="Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          {/* Email */}
          <TextField
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            sx={{ marginBottom: "1rem" }}
          />

          {/* Add Contact Button */}
          <Button
            variant="contained"
            color="primary"
            disabled={!fullName}
            onClick={handleAddContact}
            style={{ marginTop: 20 }}
          >
            Add Contact
          </Button>

          {/* Cancel Button */}
          <Button
            variant="contained"
            color="secondary"
            onClick={handleCloseModal}
            style={{ marginTop: 20 }}
            sx={{ marginLeft: "1rem" }}
          >
            Cancel
          </Button>
        </div>
      </Modal>
      <Box
        sx={{
          display: "flex",
          // flexDirection:"column",
          flexDirection: {
            xs: "column", // Column layout for extra-small and small screens
            md: "row",    // Row layout for medium and larger screens
          },
          gap: 2, // Adds space between the sections
          width: "100%",
        }}
      >
        {/* Contact Selection (Left side) */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            transition: "width 0.3s ease",
          }}
        >
          <Card
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: 2,
              mb: 2,
              p: 2,
            }}
            ref={(el) => {
              if (el) {
                const anyVisible = [...document.querySelectorAll(".autoFillSelect")]
                  .some((el) => el.style.display !== "none");
                el.style.display = anyVisible ? "flex" : "none";
              }
            }}
          >
            {hasTwoOptionRadio && (
              <Box sx={{
                mt: 2,
                mb: 3,
                p: 3,
                bgcolor: '#f5f5f5',
                borderRadius: 1,
                border: '1px solid #e0e0e0'
              }}>
                <Typography variant="body2" gutterBottom sx={{ mb: 2 }} >
                  If you would like to select No for all radio buttons in this form, you can click this button.
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => {
                    updateAllNo();
                    setSelectAllNoActive(true);
                  }}
                  disabled={selectAllNoActive}
                >
                  Select No everywhere
                </Button>
              </Box>
            )}
            <Typography variant="h6">
              Auto-Filling Contact Information
            </Typography>
            <p style={{ fontSize: "15px" }}>
              Select a contact from a pull-down box to have its information auto-filled
              in the form. Alternatively, you can type in the last name or full name
              of a contact in any field labelled <span style={{ fontWeight: "700" }}> Last Name </span>
              or just <span style={{ fontWeight: "700" }}> Name </span> in the form. As soon as you do that,
              the remaining fields in that section will be auto-filled with that contact's information.
            </p>
            {autoFillDetails?.map(({ prefix }) => (
              <Box
                className="autoFillSelect"
                sx={{ flex: 1 }}
                ref={(el) => {
                  if (el) {
                    const formFieldCollections = childRef.current?.formFieldCollections;

                    if (Array.isArray(formFieldCollections)) {
                      const hasField = formFieldCollections.some(
                        (field) =>
                          field.name === `${prefix}lastName` || field.name === `${prefix}fullName`
                      );
                      el.style.display = hasField ? "block" : "none";
                    }
                    else if (formFieldCollections && typeof formFieldCollections === "object") {
                      const fields = Object.values(formFieldCollections);
                      const hasField = fields.some(
                        (field) =>
                          field.name === `${prefix}lastName` || field.name === `${prefix}fullName`
                      );
                      el.style.display = hasField ? "block" : "none";
                    }

                    else {
                      // console.warn("formFieldCollections is not iterable or does not exist.");
                      el.style.display = "none";
                    }
                  }
                }}
              >
                <div style={{ position: "relative" }}>
                  <div
                    className="addFromAutofillContactSection"
                    onClick={() => handleOpenModal(prefix)}
                  >
                    <AddIcon />
                  </div>
                  <InfiniteScrollSelect
                    collectionName="contacts"
                    label="fullName"
                    inputLabel={`Select ${names?.[prefix]}`}
                    onChange={(event, newValue, valueData) =>
                      handleSelectChange(newValue, valueData, prefix)
                    }
                  />
                </div>
              </Box>
            ))}

            {childRef.current?.formFieldCollections && (() => {
              const formFieldCollections = childRef.current.formFieldCollections;
              const fields = Object.values(formFieldCollections);
              const sections = new Set();

              fields.forEach(field => {
                const sectionMatch = field.name?.match(/^sec\d+/);
                if (sectionMatch) {
                  sections.add(sectionMatch[0]);
                }
              });


              const sectionArray = Array.from(sections).sort((a, b) => parseInt(a.slice(3)) - parseInt(b.slice(3)));

              return (
                <>
                  {sectionArray.map((section, index) => (
                    <div key={index} style={{ position: "relative" }}>
                      <div
                        className="addFromAutofillContactSection"
                        onClick={() => handleOpenModal(section)}
                      >
                        <AddIcon />
                      </div>
                      <InfiniteScrollSelect
                        collectionName="contacts"
                        label="fullName"
                        inputLabel={`Auto-fill section ${section.slice(3)}`}
                        onChange={(event, newValue, valueData) =>
                          handleSelectChange(newValue, valueData, section)
                        }
                      />
                    </div>
                  ))}
                </>
              );
            })()}





          </Card>
        </Box>

        {/* PDF Viewer (Right side) */}
        <Box sx={{ flex: 3 }}>

          <form id="pdfComponent">
            <PdfViewerComponent
              id="container"
              downloadStart={handleDownloadStart}
              // toolbarClick={handlePdfToolbarClick}
              documentPath={window.location.origin + "/pdfs/" + formToView.fileName}
              resourceUrl="https://cdn.syncfusion.com/ej2/27.2.5/dist/ej2-pdfviewer-lib"
              enableVirtualization={false}
              enablePrint={true}
              style={{ height: "calc(100vh - 240px)" }}
              signatureDialogSettings={{
                displayMode: DisplayMode.Draw | DisplayMode.Text | DisplayMode.Upload,
                hideSaveSignature: true,
              }}
              formFieldLoad={() => {
                setTimeout(() => listenForFormFieldChanges(), 0);
              }}

              documentLoad={onDocLoad}
              documentLoadComplete={onDocLoadComplete}

              //       formFieldClick={handleFormFieldClick}
              // formFieldChange={handleFormFieldChange}
              pageChange={() => {
                if (selectAllNoActive) {
                  // run it again as soon as each page comes into view
                  updateAllNo();
                }
                onPageChange();  //existing pageChange logic
              }} ref={childRef}
              downloadEnd={downloadEnd}
              toolbarSettings={{
                showTooltip: true,
                toolbarItems: [
                  "UndoRedoTool", "PageNavigationTool", "MagnificationTool", "PanTool",
                  "SelectionTool", "CommentTool", "AnnotationEditTool", "FreeTextAnnotationOption",
                  "InkAnnotationOption", "ShapeAnnotationOption", "StampAnnotation",
                  "SignatureOption", "SearchOption",
                  ...(isInactive ? [] : ["PrintOption"]),
                  ...(isInactive ? [] : ["DownloadOption"]),
                ],
                annotationToolbarItems: [
                  "HighlightTool", "UnderlineTool", "StrikethroughTool", "ColorEditTool",
                  "OpacityEditTool", "AnnotationDeleteTool", "StampAnnotationTool",
                  "HandWrittenSignatureTool", "InkAnnotationTool", "ShapeTool", "CalibrateTool",
                  "StrokeColorEditTool", "ThicknessEditTool", "FreeTextAnnotationTool",
                  "FontFamilyAnnotationTool", "FontSizeAnnotationTool", "FontStylesAnnotationTool",
                  "FontAlignAnnotationTool", "FontColorAnnotationTool", "CommentPanelTool",
                ],
              }}
            >
              <Inject
                services={[
                  Toolbar, Magnification, Navigation, Annotation, LinkAnnotation, BookmarkView,
                  ThumbnailView, Print, TextSelection, TextSearch, FormFields
                ]}
              />
            </PdfViewerComponent>
          </form>
        </Box>
      </Box>




      {/* Action Buttons */}
      <Box
        sx={{
          position: "fixed",
          bottom: "1rem",
          right: "1rem",
          zIndex: 1000,
          "& > :not(style)": { m: 1 },
        }}
      >
        {!isInactive && (
          <Fab
            color="primary"
            aria-label="add"
            variant="extended"
            onClick={onHandleSave}
            sx={{ mr: 1 }}
            disabled={isInactive}
          >
            <Save sx={{ mr: 1 }} />
            Save
          </Fab>
        )}
        <Fab
          color="secondary"
          aria-label="add"
          variant="extended"
          onClick={handleCloseViewer}
        >
          <Clear sx={{ mr: 1 }} />
          Close
        </Fab>
      </Box>

      <Snackbar
        open={feedbackMessage.open}
        autoHideDuration={2000}
        onClose={handleCloseFeedbackMessage}
      >
        <Alert
          onClose={handleCloseFeedbackMessage}
          severity={feedbackMessage.severity}
          sx={{ width: "100%" }}
        >
          {feedbackMessage.message}
        </Alert>
      </Snackbar>
      <DownloadConfirmDialog
        open={confirmOpen}
        onCancel={handleCancelDownload}
        onProceed={handleProceedDownload}
        message={
          <>
            Currently, downloaded forms can only be viewed using Firefox. Firefox is a web browser that is{" "}
            <Link
              href="https://www.mozilla.org/firefox"
              target="_blank"
              rel="noopener noreferrer"
            >
              freely available for download
            </Link>
            .
          </>
        }
      />

    </div>
  );
};

export default PDFViewer;